import { useNavigate, useParams } from 'react-router'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Spinner } from '@phosphor-icons/react'
import { Button } from '@/components/ui'
import { useVerifyQuery } from '@/feature/auth/api'
import { useStep } from '@/lib/hooks/useStep'
import { WizardSuccessScreen } from '@/components/shared/WizardSuccessScreen'
import { LogoExtended } from '@/routes/layouts/public-layout'
import WarningIcon from './assets/Warning.svg'

export const ConfirmScreen = () => {
  const { token } = useParams<{ token: string }>()
  const { isSuccess, isError } = useVerifyQuery(token!)
  const [, actions] = useStep(2)
  const navigate = useNavigate()
  const goToDashboard = useCallback(() => navigate(`/`), [navigate])
  const lastItemUtils = useMemo(() => ({ ...actions, goToNextStep: goToDashboard }), [goToDashboard, actions])
  const { t } = useTranslation(`wizard`)
  const { t: commonT } = useTranslation(`common`)

  if (isSuccess) {
    return (
      <div className='h-full w-full bg-white p-8'>
        <WizardSuccessScreen actions={lastItemUtils}>
          <div>
            <h1 className='text-center text-4xl font-medium'>{t(`sign_up.screens.confirm.success.title`)}</h1>
            <p className='mt-1 text-center text-muted-foreground'>{t(`sign_up.screens.confirm.success.description`)}</p>
          </div>
        </WizardSuccessScreen>
      </div>
    )
  }
  if (isError) {
    return (
      <div className='flex h-full w-full flex-col items-center justify-between bg-white p-8'>
        <LogoExtended />
        <div className='max-w-md'>
          <div className='flex flex-col items-center justify-between gap-8'>
            <h1 className='text-center text-4xl font-medium'>{t(`sign_up.screens.confirm.error.title`)}</h1>
            <img src={WarningIcon} alt='Warning icon' width={156} height={157} />

            <p className='mt-1 text-center text-muted-foreground'>{t(`sign_up.screens.confirm.error.description`)}</p>
          </div>
        </div>
        <Button onClick={() => navigate(`/auth/login`)}>{commonT(`button.login`)}</Button>
      </div>
    )
  }
  return (
    <div className='flex h-full w-full flex-col items-center justify-center bg-white p-8'>
      <Spinner className='h-10 w-10 animate-spin' />
    </div>
  )
}
